var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron_up_down",
    "data-name": "chevron_up_down",
    transform: "translate(0.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4632",
    "data-name": "Ret\\xE2ngulo 4632",
    width: 12,
    height: 12,
    transform: "translate(-0.182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Arrow_-_Right_2",
    "data-name": "Iconly/Light/Arrow - Right 2",
    transform: "translate(2.926 4.037) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Right_2",
    "data-name": "Arrow - Right 2",
    transform: "translate(0 5.852) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M5.852,0,2.926,2.926,0,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Arrow_-_Right_2-2",
    "data-name": "Iconly/Light/Arrow - Right 2",
    transform: "translate(8.778 7.963) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Right_2-2",
    "data-name": "Arrow - Right 2",
    transform: "translate(0 5.852) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1-2",
    "data-name": "Stroke 1",
    d: "M5.852,0,2.926,2.926,0,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDown);
export default __webpack_public_path__ + "static/media/chevron_up_down.defd708706f58343483d5638a747cdd7.svg";
export { ForwardRef as ReactComponent };